function toFiniteTimestamp(value) {
  return Number.isFinite(value) ? value : null;
}

export function applyPointServerFields(previousPoints, pointId, serverPoint, fields = []) {
  const targetPointId = pointId ?? serverPoint?.id;
  if (!targetPointId || !serverPoint) return previousPoints;

  return previousPoints.map((point) => {
    if (point.id !== targetPointId) return point;

    const currentUpdatedAt = toFiniteTimestamp(point.updatedAt);
    const incomingUpdatedAt = toFiniteTimestamp(serverPoint.updatedAt);
    const canApplyRequestedFields =
      incomingUpdatedAt == null ||
      currentUpdatedAt == null ||
      incomingUpdatedAt >= currentUpdatedAt;

    const nextPoint = { ...point };

    if (canApplyRequestedFields) {
      fields.forEach((field) => {
        if (Object.prototype.hasOwnProperty.call(serverPoint, field)) {
          nextPoint[field] = serverPoint[field];
        }
      });

      if (Object.prototype.hasOwnProperty.call(serverPoint, "updatedAt")) {
        nextPoint.updatedAt = serverPoint.updatedAt;
      }

      if (
        Object.prototype.hasOwnProperty.call(serverPoint, "projectId") &&
        serverPoint.projectId != null
      ) {
        nextPoint.projectId = serverPoint.projectId;
      }

      if (
        Object.prototype.hasOwnProperty.call(serverPoint, "paftaId") &&
        serverPoint.paftaId != null
      ) {
        nextPoint.paftaId = serverPoint.paftaId;
      }

      if (
        Object.prototype.hasOwnProperty.call(serverPoint, "pafta") &&
        serverPoint.pafta
      ) {
        nextPoint.pafta = serverPoint.pafta;
      }
    }

    if (
      nextPoint.createdAt == null &&
      Object.prototype.hasOwnProperty.call(serverPoint, "createdAt") &&
      serverPoint.createdAt != null
    ) {
      nextPoint.createdAt = serverPoint.createdAt;
    }

    return nextPoint;
  });
}
